<template>
  <div id="contenedor-main-listado-insumos-contrato">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoInsumos="listadoInsumos"></desktop>
    </template>
    <template v-else>
      <desktop :listadoInsumos="listadoInsumos"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoInsumos',
  props: {
    listadoInsumos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
